export default __webpack_public_path__ + "static/media/paging_first_disabled.e0b69c3c.svg";